document.addEventListener("DOMContentLoaded", function () {
  // if (document.querySelector('.ingredients_product-slider')) {
  //   new Splide(".ingredients_product-slider", {
  //     type: "slide",
  //     perPage: 3,
  //     gap: 20,
  //     arrows: false,
  //     drag: false,
  //     breakpoints: {
  //       1023: {
  //         gap: 15,
  //         arrows: true,
  //         drag: true,
  //         perPage: 2,
  //       },
  //       767: {
  //         gap: 10,
  //         arrows: true,
  //         drag: true,
  //         perPage: 1,
  //       },
  //     },
  //   }).mount();
  // }
  if (document.querySelector('.multimineral-ingredients-slider, .ingredients_product-slider')) {
    new Splide(".multimineral-ingredients-slider, .ingredients_product-slider", {
      type: "slide",
      type: "loop",
      perPage: 2,
      gap: 32,
      arrows: false,
      drag: true,
      padding: "10rem",
      pagination: false,
      drag: "free",
      breakpoints: {
        1023: {
          pagination: true,
          arrows: true,
          drag: true,
          perPage: 2,
          gap: 15,
          padding: "0",
        },
        767: {
          type: "slide",
          gap: 10,
          pagination: true,
          arrows: true,
          drag: true,
          perPage: 1,
        },
      },
    }).mount();
  }

  const accordionTitles = document.querySelectorAll(".accordion-question");

  accordionTitles.forEach((title) => {
    const content = title.nextElementSibling;
    content.style.height = "0";
    content.style.overflow = "hidden";
    content.style.transition = "height 0.3s ease";

    title.addEventListener("click", function () {
      accordionTitles.forEach((otherTitle) => {
        if (otherTitle !== this) {
          otherTitle.classList.remove("open");
          const otherContent = otherTitle.nextElementSibling;
          otherContent.style.height = "0";
        }
      });

      this.classList.toggle("open");
      const btn = this.querySelector(".accordion-btn");
      const isOpen = this.classList.contains("open");

      if (isOpen) {
        content.style.height = content.scrollHeight + "px";
      } else {
        content.style.height = "0";
      }
    });
  });

  new Splide(".announcement-slider", {
    drag: false,
    breakpoints: {
      767: {
        arrows: false,
      },
    },
  }).mount();

  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const targetID = this.getAttribute("href");
      const targetElement = document.querySelector(targetID);

      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop + 120, // Adjust for header if needed
          behavior: "smooth",
        });
      }
    });
  });

  const splideVideo = new Splide(".proven--video_slider", {
    type: "slide",
    perPage: 3,
    updateOnMove: true,
    drag: "free",
    pagination: false,
    gap: "60px",
    arrows: false,
    breakpoints: {
      1080: {
        perPage: 3,
        gap: "30px",
        padding: 0,
      },
      767: {
        perPage: 1,
        gap: "20px",
        padding: { left: "0", right: "45%" },
      },
    },
  });

  splideVideo.on("move", () => {
    pauseAllVideos();
  });

  splideVideo.mount();

  // === Play/Pause functionality ===
  const playButtons = document.querySelectorAll(".proven-video__play");
  playButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const video = this.closest(".proven--video_slide").querySelector("video");
      const playIcon = this.getAttribute("data-icon-play");
      const pauseIcon = this.getAttribute("data-icon-pause");

      if (video.paused) {
        pauseAllVideos(video); // 🔁 Pause all other videos
        video.play();
        this.innerHTML = pauseIcon;
      } else {
        video.pause();
        this.innerHTML = playIcon;
      }
    });
  });

  function pauseAllVideos(except = null) {
    const videos = document.querySelectorAll(".proven--video_slide video");
    videos.forEach((vid) => {
      if (vid !== except && !vid.paused) {
        vid.pause();
        const playButton = vid
          .closest(".proven--video_slide")
          .querySelector(".proven-video__play");
        if (playButton) {
          const playIcon = playButton.getAttribute("data-icon-play");
          playButton.innerHTML = playIcon;
        }
      }
    });
  }

  // === Mute/Unmute functionality ===
  const muteButtons = document.querySelectorAll(".proven-video__mute");
  muteButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const video = this.closest(".proven--video_slide").querySelector("video");
      const muteIcon = this.getAttribute("data-icon-mute");
      const unmuteIcon = this.getAttribute("data-icon-unmute");

      video.muted = !video.muted;
      this.innerHTML = video.muted ? muteIcon : unmuteIcon;
    });
  });

  // === Fullscreen functionality ===
  const fullscreenButtons = document.querySelectorAll(
    ".proven-video__fullscreen"
  );

  fullscreenButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const video = this.closest(".proven--video_slide").querySelector("video");

      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) {
          // Safari
          video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) {
          // IE11
          video.msRequestFullscreen();
        }
      }
    });
  });

  if (document.querySelector('.proven-ingredients_slider')) {
    new Splide(".proven-ingredients_slider", {
      type: "slide",
      type: "loop",
      perPage: 2,
      gap: 32,
      arrows: false,
      drag: true,
      padding: "10rem",
      pagination: false,
      drag: "free",
      breakpoints: {
        1023: {
          pagination: true,
          arrows: true,
          drag: true,
          perPage: 2,
          gap: 15,
          padding: "0",
        },
        767: {
          type: "slide",
          gap: 10,
          pagination: true,
          arrows: true,
          drag: true,
          perPage: 1,
        },
      },
    }).mount();
  }

  const monthNames = [
    "January", "February", "March", "April", "May", "June", 
    "July", "August", "September", "October", "November", "December"
  ];
  
  const now = new Date();
  const currentMonth = monthNames[now.getMonth()];

  // Select the first <strong> inside the <p> tag
  if (document.querySelector('#current-month strong')) {
    document.querySelector('#current-month strong').textContent = currentMonth;
  }
});

function initScrollToTop() {
  const scrollBtns = document.querySelectorAll('[data-scroll-top]');
  
  scrollBtns.forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      const href = btn.getAttribute("href");

      // If blank or just "#", scroll to top
      if (href === "" || href === "#") {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
      } 
      // If href starts with "#id"
      else if (href.startsWith("#")) {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({ behavior: "smooth" });
        } else {
          // fallback: no match → scroll top
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", initScrollToTop);

// Shopify theme editor events
document.addEventListener("shopify:section:load", initScrollToTop);
document.addEventListener("shopify:section:select", initScrollToTop);